import { WHATSAPP_BASE_URL, SUPPORT_WHATSAPP_NUMBER } from '@bv/constants/whatsapp';
import { ensureArray } from '@bv/utils/common/array/ensure-array';

/**
 * Get the support WhatsApp URL with an optional message.
 * @param message - The message to send. Accepts a string or an array of lines joined with `\n`.
 * @returns The support WhatsApp URL with the message encoded.
 * @example
 * getSupportWhatsappUrl('Hello, how are you?');
 * // Returns: https://api.whatsapp.com/send?phone=966920007031&text=Hello,%20how%20are%20you%3F
 * @example
 * getSupportWhatsappUrl();
 * // Returns: https://api.whatsapp.com/send?phone=966920007031
 */
export const getSupportWhatsappUrl = (message?: string | string[]): string => {
  const baseUrl = `${WHATSAPP_BASE_URL}?phone=${SUPPORT_WHATSAPP_NUMBER}`;

  if (message) {
    const internalMessage = ensureArray(message).join('\n');
    return `${baseUrl}&text=${encodeURIComponent(internalMessage)}`;
  }

  return baseUrl;
};
